import { GridRowSelectionModel, GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import PageLayout from "../../../../../components/PageLayout";
import { DEF_PAGINATION, DGT_Pagination } from "../../../../../utils/utils";
import { useClaimListLite } from "../../../../../queries/billings/claims/use-claim-list-lite";
import BillingReportKPICards from "./BillingReportKPICards";
import BillingReportTable from "./BillingReportTable";
import { BillingReportFilterData } from "./billing-report-constants";
import { extractFilterValue, resolveDateRange } from "../report-constants";

interface BillingSchedulingReportProps {
  filters: BillingReportFilterData;
  onFilterChange: (filters: BillingReportFilterData) => void;
  rowSelectionModel: GridRowSelectionModel;
  onRowSelectionModelChange: (model: GridRowSelectionModel) => void;
}

const BillingSchedulingReport = ({
  filters,
  rowSelectionModel,
  onRowSelectionModelChange,
}: BillingSchedulingReportProps) => {
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const resolved = resolveDateRange(
    filters.date_range,
    filters.startDate,
    filters.endDate
  );
  const startDate = resolved.startDate;
  const endDate = resolved.endDate;

  const providerVal = extractFilterValue(filters.provider_Name);
  const locationVal = extractFilterValue(filters.location);
  const statusVal = extractFilterValue(filters.claim_Status);

  const providerUuids = providerVal ? [providerVal] : undefined;
  const locationUuids = locationVal ? [locationVal] : undefined;
  const claimStatuses = statusVal ? [statusVal] : undefined;
  const searchKey = filters.insurance || undefined;

  const {
    data: responseData,
    isLoading: listLoading,
    isRefetching: listRefetching,
  } = useClaimListLite({
    pagination,
    gridSorting,
    startDate,
    endDate,
    providerUuids,
    claimStatuses,
    locationUuids,
    searchKey,
  });

  const statsData = responseData?.data;
  const claimsData = responseData?.data?.claims;

  return (
    <PageLayout
      header={
        <BillingReportKPICards data={statsData} isLoading={listLoading} />
      }
    >
      <BillingReportTable
        rows={claimsData?.content ?? []}
        rowCount={claimsData?.page?.totalElements ?? 0}
        loading={listLoading || listRefetching}
        pagination={pagination}
        onPaginationChange={setPagination}
        gridSorting={gridSorting}
        onSortChange={setGridSorting}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={onRowSelectionModelChange}
      />
    </PageLayout>
  );
};

export default BillingSchedulingReport;
